import { defineMessages } from '@redbubble/next/intl';

export const unavailableItemMessages = defineMessages({
  expiredItem: {
    defaultMessage:
      'One or more items in your cart have been removed because they are no longer available for purchase.',
  },
  nonSaleableItem: {
    defaultMessage:
      'Sorry, something in your cart can’t be sold in your country and was removed from your order. Learn more.',
  },
});
